import '../styles/Payroll.css';
import Sidebar from '../components/Sidebar';
import React, { useEffect, useState, useRef } from 'react';
import EmployeeHeader from '../components/EmployeeHeader';

const Payroll = () => {
  // Sample payroll data
  const payrollData = [
    { id: 1, name: 'John Doe', month: 'May 2023', basic: 5000, allowances: 1000, deductions: 500, net: 5500, status: 'Paid' },
    { id: 2, name: 'Jane Smith', month: 'May 2023', basic: 6000, allowances: 1200, deductions: 600, net: 6600, status: 'Paid' },
    { id: 3, name: 'Robert Johnson', month: 'May 2023', basic: 5500, allowances: 1100, deductions: 550, net: 6050, status: 'Pending' },
    { id: 4, name: 'Emily Davis', month: 'May 2023', basic: 4500, allowances: 900, deductions: 450, net: 4950, status: 'Paid' },
    { id: 5, name: 'Michael Brown', month: 'May 2023', basic: 7000, allowances: 1400, deductions: 700, net: 7700, status: 'Paid' },
  ];

  const [currentEmployee, setCurrentEmployee] = useState({
      photo: 'https://randomuser.me/api/portraits/men/32.jpg',
      name: '',
      id: '',
      role: ''
    });
  
    const [showPopup, setShowPopup] = useState(false);
    const popupRef = useRef(null);
    const buttonRef = useRef(null);
  
    useEffect(() => {
      const userCode = sessionStorage.getItem('user_code');
      const userName = sessionStorage.getItem('user_name');
      const userRole = sessionStorage.getItem('user_role');
      setCurrentEmployee((prev) => ({
        ...prev,
        name: userName,
        id: userCode,
        role: userRole || 'User'
      }));
    }, []);

  return (
    <><EmployeeHeader
        currentEmployee={currentEmployee}
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        popupRef={popupRef}
        buttonRef={buttonRef}
      />
    <div className="payroll-container">
      {/* <Header /> */}
      <div className="payroll-content">
        {/* <Sidebar /> */}
        <main className="main-content">
          <h2>Payroll</h2>
          <div className="payroll-table-container">
            <table className="payroll-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Month</th>
                  <th>Basic</th>
                  <th>Allowances</th>
                  <th>Deductions</th>
                  <th>Net Pay</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {payrollData.map((record) => (
                  <tr key={record.id}>
                    <td>{record.id}</td>
                    <td>{record.name}</td>
                    <td>{record.month}</td>
                    <td>${record.basic}</td>
                    <td>${record.allowances}</td>
                    <td>${record.deductions}</td>
                    <td>${record.net}</td>
                    <td>
                      <span className={`status-badge ${record.status.toLowerCase()}`}>
                        {record.status}
                      </span>
                    </td>
                    <td>
                      <button className="action-button view">View</button>
                      <button className="action-button download">Download</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
    </>
  );
};

export default Payroll;